import React, { useMemo } from "react";
import { Typography, Box } from "@mui/material";
import { TouchApp, AutoAwesome } from "@mui/icons-material";

import { INVITATION_OCCASION, Invitations } from "../../../../../store/services/invitations/dto/invitations.dto";
import { RingsEntranceWrapper } from "./styles";
import { LANG_AR, LANG_EN, RTL } from "../../../../../Components/Templates/WeddingTemplates/constants";
import langEN from "../../../../../Components/Templates/WeddingTemplates/lang.EN.json";
import langAR from "../../../../../Components/Templates/WeddingTemplates/lang.AR.json";
import { TemplateColorObject } from "../../../../../InvitationColorMatrix";

const RingsEntrance = ({
	isOpened,
	setIsOpened,
	selectedInvitation,
	colorMatrix,
	preview
}: {
	isOpened: boolean;
	setIsOpened: React.Dispatch<React.SetStateAction<boolean>>;
	selectedInvitation: Invitations;
	colorMatrix: TemplateColorObject;
	preview?: boolean;
}) => {
	const lang = selectedInvitation?.language === LANG_EN ? langEN : langAR;

	const invitationType = useMemo(() => {
		if (!selectedInvitation) return;
		switch (selectedInvitation?.occasion) {
			case INVITATION_OCCASION.KATB_KTAB: {
				return lang.the_katb_ktab_of;
			}
			case INVITATION_OCCASION.ENGAGEMENT: {
				return lang.the_engagement_of;
			}
			default: {
				return lang.the_wedding_of;
			}
		}
	}, [selectedInvitation]);

	return (
		<RingsEntranceWrapper
			className={`${isOpened ? "hide" : "show"} ${preview ? "preview" : ""}`}
			onClick={() => setIsOpened(true)}
			colormatrix={colorMatrix}
		>
			<div className={"bg_flowers"}>
				{[1, 2, 3, 4].map(flowerIndex => (
					<div key={flowerIndex} className={`flower flower_${flowerIndex}`}>
						{Array.from({ length: 6 }).map((_, petalIndex) => (
							<span key={petalIndex} className={"petal"} />
						))}
						<span className={"center"} />
					</div>
				))}
			</div>
			<div className={`rings_wrapper ${isOpened ? "united" : ""}`}>
				<div className={"ring ring_left"} />
				<div className={"ring ring_right"} />
				<div className={`sparkles ${isOpened ? "burst" : ""}`}>
					<AutoAwesome className={"sparkle sparkle_1"} />
					<AutoAwesome className={"sparkle sparkle_2"} />
					<AutoAwesome className={"sparkle sparkle_3"} />
					<AutoAwesome className={"sparkle sparkle_4"} />
				</div>
			</div>

			<div className={`couples_banner ${selectedInvitation?.language === LANG_AR && RTL}`}>
				<Typography className={"wedding_of"}>{invitationType}</Typography>
				<Box display={"flex"} justifyContent={"center"} gap={1}>
					<Typography className={"couples groom"}>{selectedInvitation?.groom_name}</Typography>
					<Typography className={"couples and"}> {lang.and} </Typography>
					<Typography className={"couples bride"}> {selectedInvitation?.bride_name} </Typography>
				</Box>
			</div>
			<Box className={"tab_continue_container"} display={"flex"} flexDirection={"column"}>
				<Box
					className={`tab_continue ${isOpened ? "animate__animated animate__fadeOut" : "animate__animated animate__headShake animate__delay-2s animate__infinite"}`}
				>
					<TouchApp />
				</Box>
				<Typography className={`tab_continue_text ${isOpened ? "animate__animated animate__fadeOut" : ""}`}>
					{lang.TAP_TO_UNITE}
				</Typography>
			</Box>
		</RingsEntranceWrapper>
	);
};

export default RingsEntrance;
